import sImg1 from "../images/services/service_image_1.webp";
import sImg2 from "../images/services/service_image_2.webp";
import sImg3 from "../images/services/service_image_3.webp";
import sImg4 from "../images/services/service_image_4.webp";
import sImg5 from "../images/services/service_image_5.webp";

import icon1 from "../images/icons/icon_code.svg";
import icon2 from "../images/icons/icon_programming_tree.svg";
import icon3 from "../images/icons/icon_building.svg";
import icon5 from "../images/icons/icon_bug.svg";
import icon6 from "../images/icons/icon_programming.svg";
import icon7 from "../images/icons/icon_analisis_2.svg";
import icon8 from "../images/icons/icon_process.svg";
import icon9 from "../images/icons/icon_chart_2.svg";
import icon10 from "../images/icons/icon_meeting.svg";
import icon11 from "../images/icons/icon_bulb_2.svg";
import icon12 from "../images/icons/game_dev.svg";
import icon13 from "../images/icons/data_analytics.svg";
import icon14 from "../images/icons/digital_marketing_branding.svg";
import icon15 from "../images/services/cyber.svg";



//sub image of Design thinking and innovation
import NPDBanner from '../images/Banners/2.jpg';
import designSubImg from '../images/design_inovation_thinking.svg';
import productSubImg from '../images/product_strategy_market_fit.jpg';
import dev_test from '../images/dev_test.jpg';
import feedback from '../images/feedback.jpg'
// business
import businessBanner from '../images/Banners/3.png'
import businessOptimization from '../images/busniess_optimization.jpg'
import digital from '../images/digital_strategy.jpg'
import operational from '../images/operational.jpg'
import echo_green from '../images/echo_green.jpg'


// digital Techonology
import legacyBanner from '../images/Banners/4.jpg'
import legacyImg from '../images/legacy_systems.jpg'
import softStruct from '../images/software_structure.jpg'
import uiDesign from '../images/ui_desing.jpg'
import cloud from '../images/cloud_memorization.jpg'


// AI Section
import AiBanner from '../images/Banners/5.png'
import AIConsulting from '../images/AIConsulting.png'
import GenerativeAI from '../images/GenerativeAI.jpg'
import NLP from '../images/NLP.jpg'
import AIDev from '../images/AIDev.jpg'

// Project Management Section Images
import projectBanner from '../images/Banners/6.png'
import projectManagement from '../images/ProjectManagement.jpg'
import productEngDev from '../images/product_eng_dev.jpg'
import devops from '../images/dev_sec_ops.jpg'
import CI_CD from '../images/web-uptime-flat-style-design-vector-illustration-stock-illustration/47.jpg'

// Testing Section
import functionalBanner from '../images/Banners/7.jpg'
import funtionalTesting from '../images/functionalTesting.jpg'
import selfHealingRobot from '../images/selfHealingRobot.jpg'
import speedOptimization from '../images/speedOptimzaitons.jpg'
import AITests from '../images/AIDrivenTests.jpg'


// Custom Software Seciton
import customSoftBanner from '../images/Banners/14.png';
import Web_App_Dev from '../images/WEB_APP_DEV.png'
import API from '../images/API.jpg'
import fullStackDev from '../images/FullStackDev.jpg'
import microStructure from '../images/microStructures.jpg'


// DataEngineering
import dataEngineering from '../images/Banners/8.jpg'

// digitalMarketingBanner
import digitalMarketingBanner from '../images/Banners/9.jpg'

// technologyAndSolutionBanner
import technologyAndSolutionBanner from '../images/Banners/10.jpg';

// cloudAutomationBanner

import cloudAutomationBanner from '../images/Banners/11.jpg';

// customerServiceAndSupportBanner
import customerServiceAndSupportBanner from '../images/Banners/1.png';

// cyberSecurityBanner

import cyberSecurityBanner from '../images/Banners/12.png';
import DataEncryptionPrivacy from '../images/Cyber/protection.png';
import ThreatDetectionPrevention from '../images/Cyber/Threat Detection & Prevention.png';
import riskAssessment from '../images/Cyber/sec_audit.png'
import security from '../images/Cyber/security.png'
import secOpMon from '../images/Cyber/sec_op_mon.png'
import OffensiveSecurity from '../images/Cyber/OffensiveSecurity.png'
import DefensiveSecurity from '../images/Cyber/DefensiveSecurity.png'
import archieng from '../images/Cyber/archieng.png'
import ThreatIntelliResearch from '../images/Cyber/ThreatIntelliResearch.png'
import GovernanceRisKCompliance from '../images/Cyber/GovernanceRisKCompliance.png'
import dfiir from '../images/Cyber/dfiir.png'
import cets from '../images/Cyber/cets.png'
import SalesBuines from '../images/Cyber/SalesBuines.jpg'
import SecurityManageent from '../images/Cyber/SecurityManageent.jpg'
import training from '../images/Cyber/training.png'


// DataEngineering

import dataEngineering1 from '../images/services/DataEngineering Service/Data Engineer 1.png';
import dataEngineering2
    from '../images/services/DataEngineering Service/Machine learning for artificial intelligence.png';
import dataEngineering3 from '../images/services/DataEngineering Service/Woman working with big data.png';
import dataEngineering4 from '../images/services/DataEngineering Service/Analytics, graphs and data visualization.png';


// Social Media

import socialMedia1 from '../images/services/SocialMedia/social-media-addiction-2025-03-17-11-27-48-utc.JPG';
import socialMedia2 from '../images/services/SocialMedia/brand identity and brand design.png';
import socialMedia3 from '../images/services/SocialMedia/seo-search-engine-optimization-2025-02-11-20-49-20-utc.jpg';
import socialMedia4 from '../images/services/SocialMedia/Social Media Influencer Marketing.png';


// Advanced Solution and Techonology

import adv1 from '../images/services/ADV Tech/Isometric Business People Showcasing a Presentation on AI Technology.png'
import adv2 from '../images/services/ADV Tech/close-up-person-work-on-silicon-chip-or-microconto-2025-01-27-03-10-35-utc.jpg'
import adv3 from '../images/services/ADV Tech/Isometric Bitcoin with Blockchain Technology Network.png';
import adv4 from '../images/services/ADV Tech/neuroscientist-does-demonstration-at-ai-forum-in-f-2025-02-19-23-57-23-utc.jpg'


// Automation

import autoMat1 from '../images/services/Automation/Automation-Technology.png';
import autoMat2 from '../images/services/Automation/cloud-computing-concept-2025-02-21-00-48-52-utc.jpg';
import autoMat3 from '../images/services/Automation/industrial automation.png';
import autoMat4 from '../images/services/Automation/Service.png';


// customer Support

import cust1 from '../images/services/CustomerSupport/Happy scene.png';
import cust2 from '../images/services/CustomerSupport/Ticketing.png';
import cust3 from '../images/services/CustomerSupport/group-of-multiethnic-business-people-putting-their-2025-03-14-01-47-30-utc.jpg';
import cust4 from '../images/services/CustomerSupport/marketing-assistant-presenting-infographics-in-a-s-2025-02-20-01-58-20-utc.jpg';

// Game development
import gameBanner from '../images/Banners/13.jpg';
import game_dev
    from '../images/game-development-concept-digital-technology-programming-codding-flat-vector-illustration/game_development.jpg'
import game_art
    from '../images/game-development-concept-digital-technology-programming-codding-flat-vector-illustration/game_Art_Design.gif'
import game3 from '../images/game-development-concept-digital-technology-programming-codding-flat-vector-illustration/5325570.jpg'
import game4 from '../images/game-development-concept-digital-technology-programming-codding-flat-vector-illustration/5325570.jpg'
import game5 from '../images/game-development-concept-digital-technology-programming-codding-flat-vector-illustration/vr.png'
import game6 from '../images/game-development-concept-digital-technology-programming-codding-flat-vector-illustration/modern-person-having-fun-with-shooting-video-games-2025-02-19-03-18-13-utc.jpg'
import game7 from '../images/game-development-concept-digital-technology-programming-codding-flat-vector-illustration/playstore.png'
const isFullScreen = window.innerWidth >= 1200; 

const Services = [
    {
        Id: "7",
        sImg: icon1,
        banner: isFullScreen ? customSoftBanner : null,
        title: "Custom Software Development & Engineering",
        slug: "custom-software-development",
        thumb1: "Software Development",
        thumb2: "Custom Engineering",
        col: "col-lg-4",
        description:
            "Our Custom Software Development & Engineering service delivers tailor-made digital solutions by blending innovative design, robust development, and scalable architectures to bring your vision to life.",
        features: [
            "Web & Mobile App Development",
            "API Development & Integration",
            "Full Stack Development",
            "Microservices Architecture",
        ],
        outComes: [
            "Craft tailor-made software solutions for your unique needs.",
            "Build scalable applications with modern architecture.",
            "Accelerate innovation with full-stack expertise.",
            "Transform ideas into robust digital products."
        ],
        subservices: [
            {
                title: "Web & Mobile App Development",
                details: "Web & Mobile App Development: This service designs and builds responsive, user-centric web and mobile applications that offer seamless digital experiences across devices.",
                subImg: Web_App_Dev,
            },
            {
                title: "API Development & Integration",
                details: "API Development & Integration: This service creates robust APIs to seamlessly connect systems, enabling efficient data exchange and enhanced functionality.",
                subImg: API,
            },
            {
                title: "Full Stack Development",
                details: "Full Stack Development: This service provides comprehensive expertise covering both front-end and back-end development, creating complete and scalable digital solutions.",
                subImg: fullStackDev,
            },
            {
                title: "Microservices Architecture",
                details: "Microservices Architecture: This service implements modular, decoupled designs that enhance scalability, flexibility, and performance across your software ecosystem.",
                subImg: microStructure,
            },
        ],
        videoId: "7wtfhZwyrcc",
        additionalImages: [sImg1, sImg2],
    },//Mobile and Web Development
    {
        Id: "4",
        sImg: icon5,
        banner: AiBanner,
        title: "AI & Advanced Intelligence Solutions",
        slug: "ai-advanced-intelligence",
        thumb1: "AI Solutions",
        thumb2: "Machine Learning",
        col: "col-lg-4",
        description:
            "Our AI & Advanced Intelligence Solutions harness the power of artificial intelligence to transform data into actionable insights, drive automation, and foster innovative decision-making across your business.",
        features: [
            "AI & Machine Learning Consulting",
            "Generative AI Solutions",
            "NLP & AI Ethics",
            "AI/ML Model Development",
        ],
        outComes: [
            "Leverage AI for smarter decision-making.",
            "Accelerate growth with machine learning innovations.",
            "Integrate cutting-edge NLP for enhanced interactions.",
            "Drive transformation with custom AI model development."
        ],
        subservices: [
            {
                title: "AI & Machine Learning Consulting",
                details: "AI & Machine Learning Consulting: This service provides expert guidance on integrating AI and machine learning into your business strategy, driving smarter decisions and innovative outcomes.",
                subImg: AIConsulting,
            },
            {
                title: "Generative AI Solutions",
                details: "Generative AI Solutions: This service leverages advanced AI models to generate innovative content and solutions, pushing the boundaries of creativity and operational efficiency.",
                subImg: GenerativeAI,
            },
            {
                title: "NLP & AI Ethics",
                details: "NLP & AI Ethics: This service ensures ethical implementation of natural language processing, balancing advanced AI capabilities with responsible, human-centric practices.",
                subImg: NLP,
            },
            {
                title: "AI/ML Model Development",
                details: "AI/ML Model Development: This service develops custom AI and machine learning models tailored to your business challenges, delivering precision, enhanced performance, and competitive advantage.",
                subImg: AIDev,
            },
        ],
        videoId: "kxopViU98Xo",
        additionalImages: [sImg4, sImg5],
    },
    {
        Id: "9",
        sImg: icon14,
        banner: digitalMarketingBanner,
        title: "Digital Marketing & Branding",
        slug: "digital-marketing-branding",
        thumb1: "Marketing",
        thumb2: "Branding",
        col: "col-lg-4",
        description:
            "Our Digital Marketing & Branding service crafts compelling digital narratives and innovative marketing strategies that elevate your brand, engage your audience, and drive measurable growth.",
        features: [
            "Social Media Management",
            "Creative Branding & Identity",
            "Performance Marketing (SEO/SEM)",
            "Influencer Marketing & Partnerships",
        ],
        outComes: [
            "Amplify your brand presence with creative digital strategies.",
            "Engage your audience with targeted social media campaigns.",
            "Boost online visibility with data-driven marketing.",
            "Drive conversions with compelling brand storytelling."
        ],
        subservices: [
            {
                title: "Social Media Management",
                details: "Social Media Management: This service develops dynamic social media strategies that boost engagement, amplify your brand’s voice, and cultivate a vibrant online community.",
                subImg: socialMedia1,
            },
            {
                title: "Creative Branding & Identity",
                details: "Creative Branding & Identity: This service crafts a distinctive brand identity that reflects your core values, resonates with your audience, and sets you apart in the market.",
                subImg: socialMedia2,
            },
            {
                title: "Performance Marketing (SEO/SEM)",
                details: "Performance Marketing (SEO/SEM): This service drives targeted traffic and conversions through strategic SEO and SEM campaigns, maximizing your online visibility and ROI.",
                subImg: socialMedia3,
            },
            {
                title: "Influencer Marketing & Partnerships",
                details: "Influencer Marketing & Partnerships: This service connects you with influential voices and strategic partners to expand your reach, build credibility, and elevate your brand presence.",
                subImg: socialMedia4,
            },
        ],
        videoId: "fJ9rUzIMcZQ",
        additionalImages: [sImg3, sImg5],
    },
    {
        Id: "1",
        sImg: icon11,
        banner: NPDBanner,
        title: "New Product Design & Innovation",
        slug: "new-product-design-innovation",
        thumb1: "Product Strategy",
        thumb2: "Innovation",
        col: "col-lg-4",
        description:
            "Our New Product Design & Innovation service propels your vision from concept to market, blending cutting-edge design thinking, strategic market alignment, agile MVP development, and customer-centric feedback integration to create products that captivate and succeed.",
        features: [
            "Design Thinking & Ideation",
            "Product Strategy & Market Fit",
            "MVP Development & Testing",
            "Customer Feedback Integration",
        ],
        outComes: [
            "Accelerate market entry with innovative product designs.",
            "Harness design thinking for breakthrough innovation.",
            "Transform concepts into high-impact market solutions.",
            "Boost user engagement with agile product development."
        ],
        subservices: [
            {
                title: "Design Thinking & Ideation",
                details: "Design Thinking & Ideation: This service harnesses creative methodologies to brainstorm and validate breakthrough product ideas that fuel innovation, ultimately accelerating your market success.",
                subImg: designSubImg,
            },
            {
                title: "Product Strategy & Market Fit",
                details: "Product Strategy & Market Fit: This service develops a tailored product roadmap that aligns with market demands, ensuring your offering is strategically positioned for optimal success and sustainable growth.",
                subImg: productSubImg,
            },
            {
                title: "MVP Development & Testing",
                details: "MVP Development & Testing: This service rapidly builds and tests a Minimum Viable Product, validating your concept with real users and paving the way for quick market entry and continuous improvement.",
                subImg: dev_test,
            },
            {
                title: "Customer Feedback Integration",
                details: "Customer Feedback Integration: This service systematically incorporates user insights into your product development cycle, driving iterative enhancements and robust business outcomes.",
                subImg: feedback,
            },
        ],
        videoId: "7e90gBu4pas",
        // additionalImages: [NPD1, sImg2],
    },
    {
        Id: "14",
        sImg: icon15,
        banner: cyberSecurityBanner,
        title: "Cyber Security Solutions",
        slug: "cyber-security-solutions",
        thumb1: "Cyber Security",
        thumb2: "Threat Protection",
        col: "col-lg-4",
        description:
            "Our Cyber Security Solutions deliver robust protection for your business by combining comprehensive security audits, proactive threat prevention, and rapid incident response to safeguard your critical assets.",
        features: [
            "Security Audits & Risk Assessment",
            "Threat Detection & Prevention",
            "Data Encryption & Privacy",
            "Incident Response & Recovery",
        ],
        outComes: [
            "Fortify your defenses with comprehensive security audits.",
            "Protect critical assets with proactive threat prevention.",
            "Secure operations with advanced data encryption.",
            "Rapidly recover from incidents with expert response plans."
        ],
        subservices: [
            {
                title: "Security Audits & Risk Assessment",
                details: "Security Audits & Risk Assessment: This service conducts comprehensive security evaluations to uncover vulnerabilities and fortify your defenses against potential risks.",
                subImg: riskAssessment,
            },
            {
                title: "Threat Detection & Prevention",
                details: "Threat Detection & Prevention: This service leverages advanced monitoring and proactive measures to detect and neutralize cyber threats before they impact your operations.",
                subImg: ThreatDetectionPrevention,
            },
            {
                title: "Data Encryption & Privacy",
                details: "Data Encryption & Privacy: This service implements cutting-edge encryption and privacy protocols to protect sensitive data and ensure compliance with industry standards.",
                subImg: DataEncryptionPrivacy,
            },
            {
                title: "Incident Response & Recovery",
                details: "Incident Response & Recovery: This service provides swift, strategic responses to cyber incidents, minimizing downtime and restoring secure operations efficiently.",
                subImg: security,
            },
            {
                title: "Security Operations & Monitoring",
                details: "Security Operations and Monitoring involves detecting, responding to threats, and investigating incidents. Key roles include SOC Analysts, Incident Responders, and Threat Hunters.",
                subImg: secOpMon,
            },
            {
                title: "Offensive Security (Attack/Simulation)",
                details: "Offensive Security focuses on simulating attacks through penetration testing and ethical hacking. Red Team Operators assess system defenses by mimicking real-world threats.",
                subImg: OffensiveSecurity,
            },
            {
                title: "Defensive Security (Protection/Hardening)",
                details: "Defensive Security involves protecting and hardening systems against threats through roles like Blue Team Operators and Security Engineers. It covers areas such as network, cloud, mobile, IoT, and application security..",
                subImg: DefensiveSecurity,
            },
            {
                title: "Security Architecture & Engineering",
                details: "This domain focuses on designing secure systems and developing security tools. Key roles include Security Architects, DevSecOps Engineers, and Security Software Developers.",
                subImg: archieng,
            },
            {
                title: "Threat Intelligence & Research",
                details: "This field involves analyzing threats, researching vulnerabilities, and understanding malware behavior. Key roles include Threat Intelligence Analysts, Malware Analysts, and Security Researchers.",
                subImg: ThreatIntelliResearch,
            },
            {
                title: "Governance, Risk, and Compliance (GRC)",
                details: "GRC ensures organizations meet security standards and manage risks effectively. It includes roles like Security Consultants, Risk Analysts, Compliance Managers, and Data Privacy Officers.",
                subImg: GovernanceRisKCompliance,
            },
            {
                title: "Digital Forensics and Incident Response (DFIR)",
                details: "DFIR focuses on investigating cyber incidents and recovering digital evidence. Forensic Analysts play a key role in identifying the cause and impact of security breaches.",
                subImg: dfiir,
            },
            {
                title: "Cryptography & Emerging Tech Security",
                details: "This area protects data using encryption and secures new technologies. It includes roles like Cryptographers and Blockchain Security Specialists.",
                subImg: cets,
            },
            {
                title: "Training, Education, and Awareness",
                details: "This domain promotes cybersecurity knowledge and safe practices through training and education. Roles include Security Awareness Trainers and Education Specialists.",
                subImg: training,
            },
            {
                title: "Security Management & Leadership",
                details: "Focused on overseeing cybersecurity strategies and recovery planning, this area includes roles like Security Administrators, Program Managers, and Disaster Recovery Specialists.",
                subImg: SecurityManageent,
            },
            {
                title: "Sales and Business Enablement",
                details: "This area bridges cybersecurity with business goals, involving roles like Cybersecurity Sales Engineers who support secure solution delivery and client needs.",
                subImg: SalesBuines,
            },
        ],
        videoId: "abc123xyz",
        additionalImages: [sImg3, sImg4],
    }, //cyber
    {
        Id: "12",
        sImg: icon12,
        banner: gameBanner,
        title: "Game Development & With Advanced Technologies",
        slug: "game-development",
        thumb1: "Game Development",
        thumb2: "Game Design",
        col: "col-lg-4",
        description:
            "Our Game Development & With Advanced Technologies cover the entire game lifecycle, from concept to release, delivering immersive experiences through cutting-edge technology and creative design.",
        features: [
            "Full-Cycle Game Development",
            "Game Art & Design",
            "Game Mechanics & AI",
            "Game Monetization & Business Solutions",
            "AR/VR & Blockchain Games",
            "Game Testing & QA",
            "Game Marketing & Publishing"
        ],
        outComes: [
            "Create engaging, high-performance games.",
            "Deliver immersive user experiences with realistic mechanics.",
            "Develop cross-platform games for PC, console, and mobile.",
            "Monetize games through strategic business solutions."
        ],
        subservices: [
            {
                title: "Full-Cycle Game Development",
                details: "End-to-end game development from concept, design, coding, to final release.",
                subImg: game_dev,
            },
            {
                title: "Game Art & Design",
                details: "Designing game UI/UX, characters, environments, and animations for a rich visual experience.",
                subImg: game_art,
            },
            {
                title: "Game Mechanics & AI",
                details: "Implementing advanced mechanics like physics, combat systems, and intelligent AI.",
                subImg: game3,
            },
            {
                title: "Game Monetization & Business Solutions",
                details: "Setting up in-app purchases, ads, and live ops to maximize revenue.",
                subImg: game4,
            },
            {
                title: "AR/VR & Blockchain Games",
                details: "Building immersive AR/VR experiences and blockchain-powered games.",
                subImg: game5,
            },
            {
                title: "Game Testing & QA",
                details: "Testing for bugs, performance, and multiplayer stability to ensure smooth gameplay.",
                subImg: game6,
            },
            {
                title: "Game Marketing & Publishing",
                details: "Creating trailers, optimizing store listings, and managing player engagement.",
                subImg: game7,
            },
        ],
        videoId: "XYZ12345",
        // additionalImages: [gameImg1, gameImg2],
    }, // Game Development
    {
        Id: "2",
        sImg: icon8,
        banner: businessBanner,
        title: "Business Strategy & Consulting",
        slug: "business-strategy-consulting",
        thumb1: "Consulting",
        thumb2: "Strategy",
        col: "col-lg-4",
        description:
            "Our Business Strategy & Consulting service empowers your enterprise with innovative insights and actionable strategies, optimizing processes, boosting operational efficiency, and driving sustainable growth in today’s dynamic digital landscape.",
        features: [
            "Business Process Optimization",
            "Digital & Product Strategy",
            "Operational Efficiency Consulting",
            "Sustainability & Green Tech Consulting",
        ],
        outComes: [
            "Drive competitive advantage with strategic insights.",
            "Optimize operations for sustainable growth.",
            "Unlock new revenue streams through expert consulting.",
            "Transform business challenges into opportunities."
        ],
        subservices: [
            {
                title: "Business Process Optimization",
                details: "Business Process Optimization: This service reengineers your workflows to eliminate inefficiencies and streamline operations, leading to sustained operational excellence and improved performance.",
                subImg: businessOptimization,
            },
            {
                title: "Digital & Product Strategy",
                details: "Digital & Product Strategy: This service crafts a forward-thinking roadmap that leverages digital tools to refine your product offerings, capturing emerging market opportunities and driving competitiveness.",
                subImg: digital,
            },
            {
                title: "Operational Efficiency Consulting",
                details: "Operational Efficiency Consulting: This service offers expert guidance to optimize resource allocation and streamline workflows, resulting in enhanced efficiency and increased profitability.",
                subImg: operational,
            },
            {
                title: "Sustainability & Green Tech Consulting",
                details: "Sustainability & Green Tech Consulting: This service integrates innovative green technologies and eco-friendly practices into your business strategy, promoting sustainable growth and a positive environmental impact.",
                subImg: echo_green,
            },
        ],
        videoId: "dQw4w9WgXcQ",
        additionalImages: [sImg2, sImg3],
    },
    {
        Id: "8",
        sImg: icon13,
        banner: dataEngineering,
        title: "Data Engineering & Analytics Solutions",
        slug: "data-engineering-analytics",
        thumb1: "Data Engineering",
        thumb2: "Analytics",
        col: "col-lg-4",
        description:
            "Our Data Engineering & Analytics Solutions empower your business with robust data infrastructures, advanced analytics, and machine learning insights that transform raw data into actionable intelligence.",
        features: [
            "Data Engineering & Architecture",
            "Data Science & Machine Learning",
            "Big Data Analytics",
            "Data Visualization & BI",
        ],
        outComes: [
            "Unlock actionable insights with smart data integration.",
            "Transform raw data into strategic business intelligence.",
            "Scale operations with robust data engineering frameworks.",
            "Empower decisions with advanced analytics and visualization."
        ],
        subservices: [
            {
                title: "Data Engineering & Architecture",
                details: "Data Engineering & Architecture: This service designs and builds resilient data infrastructures that underpin effective analytics and drive informed decision-making.",
                subImg: dataEngineering1,
            },
            {
                title: "Data Science & Machine Learning",
                details: "Data Science & Machine Learning: This service leverages advanced data science techniques and machine learning algorithms to extract actionable insights and fuel innovation.",
                subImg: dataEngineering2,
            },
            {
                title: "Big Data Analytics",
                details: "Big Data Analytics: This service processes vast datasets with precision, uncovering trends and patterns that inform strategic business decisions.",
                subImg: dataEngineering3,
            },
            {
                title: "Data Visualization & BI",
                details: "Data Visualization & BI: This service transforms complex data into clear, interactive visualizations and dashboards that empower strategic, data-driven decision-making.",
                subImg: dataEngineering4,
            },
        ],
        videoId: "CevxZvSJLk8",
        additionalImages: [sImg2, sImg4],
    },
    {
        Id: "11",
        sImg: icon6,
        banner: cloudAutomationBanner,
        title: "Cloud & Business Process Automation",
        slug: "cloud-business-automation",
        thumb1: "Cloud Solutions",
        thumb2: "Automation",
        col: "col-lg-4",
        description:
            "Our Cloud & Business Process Automation service transforms your IT infrastructure with agile cloud solutions and automated processes, delivering scalable, secure, and efficient digital operations.",
        features: [
            "CloudOps & Automation",
            "Cloud Migration (AWS, Azure, GCP)",
            "Business Process Automation",
            "Serverless Computing Solutions",
        ],
        outComes: [
            "Elevate efficiency with seamless cloud integration.",
            "Automate business processes for agile operations.",
            "Reduce overhead with scalable cloud solutions.",
            "Accelerate digital transformation with smart automation."
        ],
        subservices: [
            {
                title: "CloudOps & Automation",
                details: "CloudOps & Automation: This service optimizes your cloud environment with automated workflows, enhancing performance while reducing manual intervention.",
                subImg: autoMat1,
            },
            {
                title: "Cloud Migration (AWS, Azure, GCP)",
                details: "Cloud Migration (AWS, Azure, GCP): This service ensures a smooth transition to top cloud platforms, providing scalability, enhanced security, and operational efficiency.",
                subImg: autoMat2,
            },
            {
                title: "Business Process Automation",
                details: "Business Process Automation: This service automates key business workflows, streamlining operations to reduce costs and boost overall productivity.",
                subImg: autoMat3,
            },
            {
                title: "Serverless Computing Solutions",
                details: "Serverless Computing Solutions: This service implements serverless architectures that eliminate infrastructure overhead while delivering scalable, cost-effective performance.",
                subImg: autoMat4,
            },
        ],
        videoId: "RgKAFK5djSk",
        additionalImages: [sImg2, sImg3],
    },
    {
        Id: "3",
        sImg: icon2,
        banner: legacyBanner,
        title: "Digital & Technology Modernization",
        slug: "digital-technology-modernization",
        thumb1: "Digital Modernization",
        thumb2: "Technology",
        col: "col-lg-4",
        description:
            "Our Digital & Technology Modernization service revitalizes outdated systems by implementing cloud-native solutions and modern architecture redesign, enhancing efficiency and transforming user experiences.",
        features: [
            "Legacy System Refactoring",
            "Enterprise Application Architecture",
            "User Experience (UX) Modernization",
            "Cloud-Native Modernization Solutions",
        ],
        outComes: [
            "Revitalize legacy systems with modern digital solutions.",
            "Empower your business with agile technology upgrades.",
            "Enhance user experience with next-gen interfaces.",
            "Streamline operations with cloud-native transformations."
        ],
        subservices: [
            {
                title: "Legacy System Refactoring",
                details: "Legacy System Refactoring: This service rejuvenates outdated IT infrastructures by transforming legacy systems into agile, scalable solutions that power your digital future.",
                subImg: legacyImg,
            },
            {
                title: "Enterprise Application Architecture",
                details: "Enterprise Application Architecture: This service designs robust and scalable system architectures that seamlessly integrate with existing operations, driving business growth.",
                subImg: softStruct,
            },
            {
                title: "User Experience (UX) Modernization",
                details: "User Experience (UX) Modernization: This service reimagines your digital interfaces, creating intuitive and engaging user experiences that boost satisfaction and loyalty.",
                subImg: uiDesign,
            },
            {
                title: "Cloud-Native Modernization Solutions",
                details: "Cloud-Native Modernization Solutions: This service transitions your applications to cloud-native environments, delivering unparalleled agility, scalability, and innovative capabilities.",
                subImg: cloud,
            },
        ],
        videoId: "9bZkp7q19f0",
        additionalImages: [sImg3, sImg4],
    },
    {
        Id: "10",
        sImg: icon7,
        banner: technologyAndSolutionBanner,
        title: "Advanced Technology & Emerging Solutions",
        slug: "advanced-technology-emerging",
        thumb1: "Emerging Tech",
        thumb2: "Innovation",
        col: "col-lg-4",
        description:
            "Our Advanced Technology & Emerging Solutions service explores the cutting edge of innovation, leveraging disruptive technologies like blockchain, IoT, AR/VR, and quantum computing to transform industries.",
        features: [
            "Robotic Process Automation (RPA)",
            "IoT Solutions",
            "Blockchain Technology",
            "Quantum Computing",
        ],
        outComes: [
            "Stay ahead with breakthrough emerging technologies.",
            "Innovate with disruptive blockchain and IoT solutions.",
            "Transform operations with automation and quantum computing.",
            "Redefine industry standards with cutting-edge tech innovations."
        ],
        subservices: [
            {
                title: "Robotic Process Automation (RPA)",
                details: "Robotic Process Automation (RPA): This service automates routine processes with intelligent RPA solutions, boosting efficiency and liberating resources for strategic initiatives.",
                subImg: adv1,
            },
            {
                title: "IoT Solutions",
                details: "IoT Solutions: This service connects devices and systems to deliver real-time insights, driving smarter operations and enhanced decision-making.",
                subImg: adv2,
            },
            {
                title: "Blockchain Technology",
                details: "Blockchain Technology: This service leverages distributed ledger technology to secure transactions, enhance transparency, and revolutionize data integrity.",
                subImg: adv3,
            },
            {
                title: "Quantum Computing",
                details: "Quantum Computing: This service harnesses the power of quantum mechanics to solve complex challenges with unprecedented speed and computational power.",
                subImg: adv4,
            },
        ],
        videoId: "hY7m5jjJ9mM",
        additionalImages: [sImg4, sImg5],
    },
    {
        Id: "6",
        sImg: icon9,
        banner: functionalBanner,
        title: "Quality Assurance & Testing Services",
        slug: "quality-assurance-testing",
        thumb1: "QA",
        thumb2: "Testing",
        col: "col-lg-4",
        description:
            "Our Quality Assurance & Testing Services ensure impeccable performance through rigorous testing methodologies, advanced automation, and AI-driven insights that deliver flawless, reliable software.",
        features: [
            "Functional & Regression Testing",
            "Self-Healing Test Automation",
            "Performance & Load Testing",
            "AI-driven Test Automation"
        ],
        outComes: [
            "Ensure flawless performance with advanced testing techniques.",
            "Automate quality checks for rapid deployment cycles.",
            "Boost reliability with real-time performance analytics.",
            "Mitigate risks with proactive, AI-driven testing."
        ],
        subservices: [
            {
                title: "Functional & Regression Testing",
                details: "Functional & Regression Testing: This service rigorously validates each function and regression, ensuring every feature operates flawlessly and meets the highest quality standards.",
                subImg: funtionalTesting,
            },
            {
                title: "Self-Healing Test Automation",
                details: "Self-Healing Test Automation: This service deploys intelligent automation that adapts and self-corrects in real time, maintaining continuous, error-free performance.",
                subImg: selfHealingRobot,
            },
            {
                title: "Performance & Load Testing",
                details: "Performance & Load Testing: This service stresses your systems under simulated heavy loads to ensure robust performance even under peak conditions.",
                subImg: speedOptimization,
            },
            {
                title: "AI-driven Test Automation",
                details: "AI-driven Test Automation: This service leverages artificial intelligence to enhance testing accuracy and efficiency, delivering adaptive quality assurance that preempts issues.",
                subImg: AITests,
            },
        ],
        videoId: "eVTXPUF4Oz4",
        additionalImages: [sImg4, sImg5],
    },

    {
        Id: "5",
        sImg: icon3,
        banner: projectBanner,
        title: "Digital Implementation & Delivery Services",
        slug: "digital-implementation-delivery",
        thumb1: "Digital Delivery",
        thumb2: "Implementation",
        col: "col-lg-4",
        description:
            "Our Digital Implementation & Delivery Services ensure seamless execution from concept to launch, integrating agile program management, innovative product engineering, and robust DevOps practices for accelerated ROI.",
        features: [
            "Program & Project Management",
            "Product Engineering & Development",
            "DevOps & SecOps Integration",
            "CI/CD & Managed Services",
        ],
        outComes: [
            "Seamlessly deploy digital solutions for rapid ROI.",
            "Master project execution with agile methodologies.",
            "Enhance product quality through integrated DevOps.",
            "Achieve operational excellence with end-to-end delivery."
        ],
        subservices: [
            {
                title: "Program & Project Management",
                details: "Program & Project Management: This service orchestrates projects with agile precision, ensuring every milestone is met efficiently for optimal delivery.",
                subImg: projectManagement,
            },
            {
                title: "Product Engineering & Development",
                details: "Product Engineering & Development: This service transforms innovative ideas into market-ready products through meticulous engineering and comprehensive development processes.",
                subImg: productEngDev,
            },
            {
                title: "DevOps & SecOps Integration",
                details: "DevOps & SecOps Integration: This service fuses development, operations, and security best practices into a unified workflow that enhances product reliability and performance.",
                subImg: devops,
            },
            {
                title: "CI/CD & Managed Services",
                details: "CI/CD & Managed Services: This service automates your deployment pipelines and continuously manages integrations, ensuring consistent, high-quality product releases.",
                subImg: CI_CD,
            },
        ],
        videoId: "TdrL3QxjyVw",
        additionalImages: [sImg1, sImg3],
    },














    {
        Id: "13",
        sImg: icon10,
        banner: customerServiceAndSupportBanner,
        title: "Customer Success & Support Services",
        slug: "customer-success-support",
        thumb1: "Customer Success",
        thumb2: "Support",
        col: "col-lg-4",
        description:
            "Our Customer Success & Support Services are dedicated to driving long-term client satisfaction and loyalty through proactive support, strategic SLA management, and continuous performance monitoring.",
        features: [
            "Post-Launch Support",
            "SLA Management",
            "Customer Engagement",
            "Performance Monitoring & Feedback",
        ],
        outComes: [
            "Enhance customer loyalty with proactive support.",
            "Drive satisfaction with real-time performance monitoring.",
            "Streamline engagement with personalized success strategies.",
            "Foster lasting relationships with dedicated post-launch care."
        ],
        subservices: [
            {
                title: "Post-Launch Support",
                details: "Post-Launch Support: This service offers continuous, hands-on assistance after your product launch, ensuring smooth operations and sustained customer success.",
                subImg: cust1,
            },
            {
                title: "SLA Management",
                details: "SLA Management: This service meticulously manages service level agreements to guarantee reliability, accountability, and exceptional service delivery.",
                subImg: cust2,
            },
            {
                title: "Customer Engagement",
                details: "Customer Engagement: This service builds lasting customer relationships through proactive, personalized engagement strategies that drive loyalty and growth.",
                subImg: cust3,
            },
            {
                title: "Performance Monitoring & Feedback",
                details: "Performance Monitoring & Feedback: This service continuously monitors system performance and gathers actionable feedback, enabling proactive improvements and enhanced user satisfaction.",
                subImg: cust4,
            },
        ],
        videoId: "6Ejga4kJUts",
        additionalImages: [sImg3, sImg4],
    },

];


export default Services;
